<script setup lang="ts">
import { NSpin } from 'naive-ui';

interface Props {
  onClose?: () => void;
  afterLeave?: () => void;
  onShow?: () => void;
  show: boolean;
  toastText?: string;
}
const props = defineProps<Props>();

onMounted(() => {
  props.onShow?.();
});
</script>

<template>
  <Transition
    name="fade"
    @after-leave="props.afterLeave"
  >
    <div
      v-if="props.show"
      class="fixed top-0 left-0 bottom-0 right-0 z-9999 flex justify-center items-center c-#ccc"
    >
      <div class="flex justify-center flex-col items-center gap-24px">
        <NSpin
          :show="true"
          stroke="#ccc"
        />
        <div class="text-14px">
          {{ toastText || '加载中 ' }}
        </div>
      </div>
    </div>
  </Transition>
</template>
